import { ConsentState, CONSENT_SUCCESS } from './types';

// action creators
export const consentSuccessAction = (config: ConsentState) => {
    return {
        payload: config,
        type: CONSENT_SUCCESS,
    };
};
